<template>
  <div class="topBar">
    <div class="openMenus">
      <el-button
        type="primary"
        :icon="Expand"
        size="large"
        circle
        @click="this.isCollapse = !this.isCollapse"
      />
      <!--      <el-button type="success" :icon="Check" circle />-->
    </div>
    <!--    <div class="logo animate__animated animate__backInLeft">-->
    <!--      <router-link :to="'/'"><img src="@/static/logo.png" /></router-link>-->
    <!--    </div>-->
    <p class="backto">
      <router-link :to="'/list'"
        ><label>{{ $t("edit.backContent") }}</label></router-link
      >
    </p>
  </div>
  <div class="panel">
    <div class="panel_left">
      <el-menu
        default-active="1"
        class="el-menu-vertical-demo"
        :collapse="isCollapse"
        @open="handleOpen"
        @close="handleClose"
      >
        <router-link :to="'/edit/' + gameId + '/cover'"
          ><el-menu-item index="1">
            <el-icon><setting /></el-icon>
            <template #title>{{ $t("edit.menu.coverSetting") }}</template>
          </el-menu-item></router-link
        >
        <router-link :to="'/edit/' + gameId + '/background'"
          ><el-menu-item index="2">
            <el-icon><Postcard /></el-icon>
            <template #title> {{ $t("edit.menu.storyBackground") }} </template>
          </el-menu-item></router-link
        >
        <router-link :to="'/edit/' + gameId + '/content'"
          ><el-menu-item index="3">
            <el-icon><document /></el-icon>
            <template #title>
              {{ $t("edit.menu.contentEdit") }}
            </template>
          </el-menu-item></router-link
        >
        <router-link :to="'/edit/' + gameId + '/role'" v-if="multiplePlayer"
          ><el-menu-item index="4">
            <el-icon><User /></el-icon>
            <template #title> 角色管理 </template>
          </el-menu-item></router-link
        >
        <router-link :to="'/edit/' + gameId + '/integral'"
          ><el-menu-item index="5">
            <el-icon><Coin /></el-icon>
            <template #title> {{ $t("edit.menu.pointManagement") }} </template>
          </el-menu-item></router-link
        >
        <router-link :to="'/edit/' + gameId + '/release'"
          ><el-menu-item index="6">
            <el-icon><Position /></el-icon>
            <template #title> {{ $t("edit.menu.published") }} </template>
          </el-menu-item></router-link
        >
        <router-link :to="'/edit/' + gameId + '/gameReview'"
          ><el-menu-item index="7">
            <el-icon><Mug /></el-icon>
            <template #title> 游戏复盘 </template>
          </el-menu-item></router-link
        >

        <router-link :to="'/edit/' + gameId + '/questionnaires'"
          ><el-menu-item index="8">
            <el-icon><DocumentCopy /></el-icon>
            <template #title> {{ $t("edit.menu.questionnaire") }} </template>
          </el-menu-item></router-link
        >
      </el-menu>
    </div>
    <div class="panel_right">
      <el-scrollbar>
        <router-view class="rv" />
      </el-scrollbar>
    </div>
  </div>
</template>

<script lang="ts">
import {
  defineComponent,
  ref,
  computed,
  watch,
  onMounted,
  onUnmounted,
} from "vue";
import {
  Document,
  Menu as IconMenu,
  Location,
  Setting,
  Check,
  User,
  Postcard,
  Expand,
  ChatLineRound,
  Position,
  Switch,
  Edit,
  DocumentChecked,
  Trophy,
  DocumentCopy,
  Coin,
  Mug,
} from "@element-plus/icons-vue";

export default defineComponent({
  name: "App",
  data(): any {
    return {
      isCollapse: false,
      gameId: "123",
    };
  },
  components: {
    Mug,
    Document,
    IconMenu,
    Location,
    Setting,
    Check,
    User,
    Position,
    ChatLineRound,
    Switch,
    Edit,
    DocumentChecked,
    Trophy,
    Coin,
    Postcard,
    DocumentCopy,
  },
  computed: {
    Expand() {
      return Expand;
    },
    Check() {
      return Check;
    },
    multiplePlayer(): boolean {
      const game = this.$store.state.game.games.find(
        (item: any) => item.id === this.$route.params.id
      );

      return game.gameClass === "多人角色剧本";
    },
  },
  watch: {
    counter(newVal: number, oldVal: number) {
      console.log(`Counter changed from ${oldVal} to ${newVal}`);
    },
    message(newVal: string, oldVal: string) {
      console.log(`Message changed from "${oldVal}" to "${newVal}"`);
    },
  },
  mounted() {
    this.gameId = this.$route.params.id;

    const game = this.$store.state.game.games.find(
      (item: any) => item.id === this.gameId
    );

    console.log(game);
  },
  methods: {
    handleOpen: (key: string, keyPath: string[]) => {},
    handleClose: (key: string, keyPath: string[]) => {},
  },
});
</script>

<style lang="less" scoped>
// 设计变量
@topbar-height: 60px;
@primary-color: #5d5fef;
@primary-light: #f0f2ff;
@text-main: #2d3748;
@text-sub: #718096;
@border-color: #edf2f7;

// 解决 router-link 默认自带的蓝色与下划线
a {
  text-decoration: none;
  color: inherit;
  display: block;
}

.topBar {
  width: 100%;
  height: @topbar-height;
  border-bottom: 1px solid @border-color;
  box-sizing: border-box;
  padding: 0 24px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(12px);
  display: flex;
  justify-content: space-between;
  align-items: center;

  .openMenus {
    display: flex;
    align-items: center;

    .el-button {
      background: @primary-light;
      border: 1px solid #dce2ff;
      color: @primary-color;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

      &:hover {
        background: @primary-color;
        color: #fff;
        transform: scale(1.05);
        box-shadow: 0 4px 12px rgba(93, 95, 239, 0.25);
      }
    }
  }

  .backto {
    margin: 0;
    display: flex;
    align-items: center;

    label {
      background: #ffffff;
      padding: 7px 18px;
      border-radius: 20px;
      font-size: 13px;
      font-weight: 500;
      color: @text-sub;
      border: 1px solid #e2e8f0;
      cursor: pointer;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);
      transition: all 0.25s ease;
      user-select: none;

      &:hover {
        background: @primary-color;
        border-color: @primary-color;
        color: #ffffff;
        box-shadow: 0 4px 12px rgba(93, 95, 239, 0.2);
        transform: translateY(-1px);
      }
    }
  }
}

.panel {
  display: flex;
  width: 100%;
  height: calc(100vh - @topbar-height);
  margin-top: @topbar-height;
  overflow: hidden;
  background-color: #f8fafc;

  &_left {
    height: 100%;
    background: #ffffff;
    border-right: 1px solid @border-color;
    transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 2px 0 10px rgba(0, 0, 0, 0.02);
    z-index: 10;
  }

  &_right {
    flex: 1;
    height: 100%;
    overflow: hidden;

    :deep(.el-scrollbar__wrap) {
      overflow-x: hidden;
    }

    .rv {
      padding: 24px;
      box-sizing: border-box;
      min-height: 100%;
    }
  }
}

// 侧边栏菜单美化
.el-menu {
  height: 100%;
  border-right: none !important;
  background: transparent;

  &:not(.el-menu--collapse) {
    width: 220px;
  }

  .el-menu-item {
    height: 48px;
    line-height: 48px;
    margin: 6px 12px;
    border-radius: 10px;
    color: @text-main;
    font-size: 14px;
    font-weight: 500;
    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);

    .el-icon {
      font-size: 18px;
      margin-right: 10px;
      color: @text-sub;
      transition: color 0.25s;
    }

    &:hover {
      background-color: #f1f5f9;
      color: @primary-color;

      .el-icon {
        color: @primary-color;
      }
    }

    // 选中激活态样式
    &.is-active {
      background: @primary-light;
      color: @primary-color;
      font-weight: 600;

      .el-icon {
        color: @primary-color;
      }

      // 菜单项右侧小指示条
      &::after {
        content: "";
        position: absolute;
        right: 0;
        top: 25%;
        height: 50%;
        width: 3px;
        background: @primary-color;
        border-radius: 4px;
      }
    }
  }
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
  height: 100%;
}

.el-menu {
  height: 100%;
}

@media screen and (max-width: 700px) {
  .topBar {
    .changeBar {
      display: block;
    }
  }
}
</style>
